import React from 'react';
import Box from '../../../../components/Box/Box';
import { Link } from '../../../../components/Link';

type TAttribute = {
  title: string;
  linkTitle?: string;
  url: string;
  onClick?: () => void;
};

const DropdownTitleWithLink = ({ title, linkTitle, url, onClick, ...rest }: TAttribute) => (
  <Box {...rest} as="div" parent="Nav-dropdown-menu" name="titleWithLink" onClick={onClick}>
    <Box as="div" name="title" parent="Nav-dropdown-menu-titleWithLink">
      {title}
    </Box>

    <Box as="div" name="linkTitle" parent="Nav-dropdown-menu-titleWithLink">
      <Link href={url}>{linkTitle}</Link>
    </Box>
  </Box>
);

export default DropdownTitleWithLink;
